// extracted by mini-css-extract-plugin
module.exports = {"homeContent":"index_homeContent__ZTNUV","desc":"index_desc__HhqUz"};